import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { FC } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    achAuthorizationContainer: {
      display: 'inline-flex',
      flexDirection: 'column',
    },
    achAuthorizationText: {
      fontSize: '0.775rem',
      margin: 0,
    },
    achAuthorizationTitle: {
      marginRight: theme.spacing(1),
    },
  }),
);

const AchAuthorizationLabel: FC = () => {
  const classes = useStyles();
  return (
    <span className={classes.achAuthorizationContainer}>
      <strong className={classes.achAuthorizationTitle}>ACH Authorization</strong>
      <span className={classes.achAuthorizationText}>
        By checking this box, I authorize <strong>the merchant</strong> to debit my bank account via the Automated Clearing House
        (&quot;ACH&quot;) network for the amount indicated. I understand that this authorization is governed by U.S. ACH rules and will
        remain in effect until revoked.
      </span>
    </span>
  );
};

export default AchAuthorizationLabel;
